exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".totalCellWrapper-556f3{font-weight:bold}", ""]);

// Exports
exports.locals = {
	"totalCellWrapper": "totalCellWrapper-556f3"
};